import { render } from "./error404Page.vue?vue&type=template&id=294a3272&scoped=true"
const script = {}

import "./error404Page.vue?vue&type=style&index=0&id=294a3272&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-294a3272"]])

export default __exports__